import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export default function Home() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center bg-navy-950 pt-16 overflow-hidden"
    >
      {/* Background glow blobs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-cyan-400/5 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-6xl mx-auto px-4 py-20 flex flex-col-reverse md:flex-row items-center gap-12 relative z-10 w-full">

        {/* Text content */}
        <div className="flex-1 text-center md:text-left">
          {/* <span className="section-tag">Welcome to my portfolio</span> */}

          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mt-2 mb-4 text-white">
            Hi, I'm{" "}
            <span className="text-cyan-400">Nakarda Richards</span>
          </h1>

          <h2 className="text-base md:text-lg font-semibold text-slate-400 mb-6 tracking-wide">
            Software Developer &nbsp;·&nbsp; Mobile &amp; Web Apps &nbsp;·&nbsp; REST APIs &nbsp;·&nbsp; ICT Instructor
          </h2>

          <p className="text-slate-400 text-base max-w-lg mx-auto md:mx-0 mb-4 leading-relaxed">
            Versatile software developer with strong experience in Python, Java, C#,
            full-stack web development, and mobile application development. Skilled in
            building scalable, user-focused applications with clean and maintainable code.
          </p>

          {/* Availability line */}
          <p className="text-sm text-cyan-400/80 max-w-lg mx-auto md:mx-0 mb-8 leading-relaxed border-l-2 border-cyan-500/40 pl-3">
            Open to full-time roles, consulting engagements, freelance projects, and collaborations.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-wrap gap-3 justify-center md:justify-start">
            <button onClick={() => scrollTo("projects")} className="btn-primary">
              View My Work
            </button>
            <button onClick={() => scrollTo("services")} className="btn-outline">
              My Services
            </button>
            <button onClick={() => scrollTo("contact")} className="btn-outline">
              Hire Me
            </button>
          </div>

          {/* Social icons */}
          <div className="flex gap-5 mt-8 justify-center md:justify-start">
            <a href="https://github.com/NakardaRichards" target="_blank" rel="noreferrer"
              aria-label="GitHub" className="text-slate-500 hover:text-cyan-400 transition-colors">
              <FaGithub size={24} />
            </a>
            <a href="https://linkedin.com/in/nakarda" target="_blank" rel="noreferrer"
              aria-label="LinkedIn" className="text-slate-500 hover:text-cyan-400 transition-colors">
              <FaLinkedin size={24} />
            </a>
            <a href="https://instagram.com/nakarda_r" target="_blank" rel="noreferrer"
              aria-label="Instagram" className="text-slate-500 hover:text-cyan-400 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="mailto:nakardarichards3@gmail.com" aria-label="Email"
              className="text-slate-500 hover:text-cyan-400 transition-colors">
              <MdEmail size={26} />
            </a>
          </div>
        </div>

        {/* Headshot */}
        <div className="flex-shrink-0 isolate">
          <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden
                          ring-2 ring-cyan-500/40 ring-offset-4 ring-offset-navy-950 shadow-glow-lg">
            <img
              src="/assets/images/headshot.jpeg"
              alt="Nakarda Richards"
              className="w-full h-full object-cover"
              style={{
                objectPosition: "center 10%",
                objectFit: "cover",
                transform: "scale(1.6)",
                transformOrigin: "center 15%",
                imageRendering: "high-quality",
                willChange: "transform",
              }}
            />
          </div>
        </div>

      </div>
    </section>
  );
}